import * as React from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Formik } from "formik";
import { Routine } from "redux-saga-routines";
import {Action, ActionFunctionAny} from "redux-actions";

import { SettingEnum as ComponentSettingEnum } from "../../settingEnum";
import { BatteryForm } from "../types";
import {  isGx8 } from "../../../DeviceHardwareEnum";
import { Footer, ButtonContainer, StyledForm } from "./styled";
import { SettingsLayout, Section, FieldGrid } from "../../Components/settingsLayout";
import Dropdown from "../../../../Elements/Dropdown/Dropdown";
import { Option } from "../../../../Elements/Dropdown/types";
import withFormWrapper from "@Elements/Form/formWrapper";
import { CancelButton, SaveButton } from "../../../DefaultSettings/Settings/styled";
import { saveBattery } from "../../Store/routines";
import SettingsHeader from "../header";
import { AppState } from "@Safemate/Store/types";
import {MiscSettingsWrapped} from "@Safemate/Settings";

interface BatteryProps extends MiscSettingsWrapped{
  dehaId: number;
  deviId: number;
  battery: BatteryForm;
  saveBattery: Routine<ActionFunctionAny<Action<any>>>;
}

const mapStateToProps = ({ settings: {initialization: { deviId, dehaId }, general: {battery}}}: AppState) => {
  return{
    battery,
    dehaId,
    deviId,
  }
}

const mapDispatchToProps = {
  saveBattery,
}

const Battery = connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(({ dehaId, deviId, components, intl: {formatMessage}, battery, saveBattery }: BatteryProps) => {

    const settingEnum = isGx8(dehaId) ? ComponentSettingEnum.GX8_BATTERY : ComponentSettingEnum.BATTERY;
    
    return(
      <Formik
        onSubmit={(values) => {
          saveBattery({
            deviceId: deviId,
            settings: values
          })
        }}
        enableReinitialize
        initialValues={battery}
      >    
        {({dirty, setValues}) => 
        <StyledForm>
          <SettingsHeader 
            title={formatMessage({id: "batteryTreshold", defaultMessage: "Batteriterskel"})}
            tooltip={isGx8(dehaId) ? "batteryAndPowerHeadlineToolTipText" : undefined}
            tooltipTitle={{
              id: "batteryAndPowerSettingsTab",
              defaultMessage: "Batteri- og strøminnstillinger"
            }}
          />
          {isGx8(dehaId)
            ? <SettingsLayout>
                {components.has(settingEnum)
                  && components.get(settingEnum)?.map((comp, i) =>
                    <React.Fragment key={i}>{comp}</React.Fragment>)}
              </SettingsLayout>
            : <SettingsLayout>
                <Section>
                  <FieldGrid>
                    {components.has(settingEnum)
                      && components.get(settingEnum)?.map((comp, i) =>
                        <div key={i}>{comp}</div>)}
                  </FieldGrid>
                </Section>
              </SettingsLayout>}
          <Footer>
            <ButtonContainer disabled={!dirty}>
              <CancelButton disabled={!dirty} onClick={() => setValues(battery)}>
                {formatMessage({id: "cancel", defaultMessage: "Avbryt"})}
              </CancelButton>
              <SaveButton disabled={!dirty} type="submit">
                {formatMessage({id: "save", defaultMessage: "Lagre"})}
              </SaveButton>
            </ButtonContainer>
          </Footer>
        </StyledForm>}
      </Formik>
    )
  })
)

export default Battery;

const batteryThresholdOpt = [
  {text: "10%", value: "10"},
  {text: "20%", value: "20"},
  {text: "30%", value: "30"},
  {text: "40%", value: "40"}
]

export const BatteryThreshold = withFormWrapper<BatteryForm>(({ formik: { values: { batteryThreshold }, setFieldValue } }) => {
  return(
    <Dropdown 
      options={batteryThresholdOpt} 
      onChange={(opt) => {
        const value: number = (opt as Option).value;
        setFieldValue("batteryThreshold", value);
      }}
      initial={batteryThreshold}
    /> 
  )
})
